import { m } from '@hub/messages';
import { ErrorPageCode } from '@platform/ui';
import type { HTMLAttributes } from 'react';

interface ErrorEventCodeProps extends HTMLAttributes<HTMLDivElement> {
  eventId: string;
}

export function ErrorEventCode({ eventId, ...props }: ErrorEventCodeProps) {
  return (
    <ErrorPageCode
      eventId={eventId}
      copyLabel={m.commons_error_page_copy_error_id()}
      copiedLabel={m.commons_error_page_copied_error_id()}
      copyFailedLabel={m.commons_error_page_copy_failed()}
      {...props}
    />
  );
}
